import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import racetrackLogo from "./images/brands/racetrack-pitstop.png";
import tubbeesLogo from "./images/brands/tubbees.png";
import hoagiesLogo from "./images/brands/hoagies.png";
import vaped4uLogo from "./images/brands/vaped4u.png";
import jediHrLogo from "./images/brands/jedi-hr-solutions.svg";
import Footer from "./Footer";

const BRANDS = [
  { name: "RaceTrack Pitstop", src: racetrackLogo },
  { name: "Vaped4U", src: vaped4uLogo },
  { name: "Hoagies", src: hoagiesLogo },
  { name: "Tubbees Dessert Lab", src: tubbeesLogo },
];

export default function Layout({ children, showFooter = true }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Box
        component="header"
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        }}
      >
        <Container
          maxWidth="md"
          sx={{
            py: { xs: 1.5, sm: 2 },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: { xs: 1.5, sm: 2 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              gap: { xs: 2, sm: 2.5 },
            }}
          >
            {BRANDS.map((brand) => (
              <Box
                key={brand.name}
                component="img"
                src={brand.src}
                alt={brand.name}
                sx={{ height: { xs: 26, sm: 34 }, width: "auto" }}
              />
            ))}
          </Box>

          <Box
            sx={{
              width: { xs: "70%", sm: "1px" },
              height: { xs: "1px", sm: 32 },
              bgcolor: "divider",
            }}
          />

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ whiteSpace: "nowrap" }}
            >
              HR Solutions provided by
            </Typography>
            <Box
              component="img"
              src={jediHrLogo}
              alt="JEDI HR Solutions"
              sx={{ height: { xs: 26, sm: 34 }, width: "auto" }}
            />
          </Box>
        </Container>

        <Box
          sx={{
            width: "100%",
            height: 4,
            background:
              "linear-gradient(90deg, #012748 0%, #0f4e6f 35%, #b66d2d 70%, #fe9816 100%)",
          }}
        />
      </Box>

      <Box component="main" sx={{ flex: 1, width: "100%" }}>
        {children}
      </Box>

      {showFooter && <Footer />}
    </Box>
  );
}
